import { combineReducers } from 'redux';
import matchListReducer from './match-list.slice'

const matchRootReducer = combineReducers({
    list: matchListReducer,
});

export default matchRootReducer;